// How the titular of a «Entrega» is named. THREE forms, like `authorizedDisplayName` — but the two
// absences it tells apart are different ones. `recipient: null` says the delivery has NO titular;
// an object whose name is missing says there IS an account and its row could not be read (a
// dangling id, or a «Usuario» taken down). The contract keeps those two facts apart on purpose, so
// the screen does too: an em dash on a delivery that never had a titular would claim the panel
// failed to read something that was never there.
//
// A name that arrives wins: if the backend can name them, that is the answer.
// TODO: i18n — copy en ES hasta Fase 1.
const UNREADABLE_ACCOUNT = '—';
const NO_TITULAR = 'Sin titular';

export function titularDisplayName(recipient: { name: string | null } | null): string {
  if (recipient === null) return NO_TITULAR;
  const named = recipient.name?.trim();
  return named !== undefined && named !== '' ? named : UNREADABLE_ACCOUNT;
}
